
import { trackSearchEvents } from '@marketplace/helpers/segment/index.js'
import { trackSource } from '@marketplace/helpers/source-tracking.js'

export default {
    name: 'SearchSuggestions',

    props: {
        suggestions: {
            type: Array,
            default: null,
        },
        label: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        query: {
            type: String,
            default: '',
        },
        isDropshipping: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        preventDefault($event) {
            $event.preventDefault()
        },
        clickSearchItem(suggestion, url) {
            const payload = {
                type: this.type,
                name: suggestion,
                url,
                query: this.query,
            }
            trackSearchEvents('clickSuggestion', payload)
            trackSource({
                name: 'search',
                fullPath: '/search',
                query: {
                    search: this.query,
                },
            })

            this.$emit('clickSuggestion', payload)

            const resolved = this.$router.resolve(url)
            const isStaticPage = ['landing-page'].includes(
                resolved?.route?.name
            )

            if (
                this.$page?.currentRouteName &&
                resolved?.route?.name &&
                !isStaticPage
            ) {
                this.$router.push({ path: this.getUrl(url) })
            } else {
                window.location.href = this.getUrl(url)
            }
        },
        highlight(query, suggestion) {
            const index = suggestion.toLowerCase().indexOf(query.toLowerCase())
            if (index >= 0) {
                suggestion =
                    suggestion.substring(0, index) +
                    '<span class="font-700">' +
                    suggestion.substring(index, index + query.length) +
                    '</span>' +
                    suggestion.substring(index + query.length)
            }

            return suggestion
        },
        getUrl(url) {
            if (this.isDropshipping) {
                return this.localeUrl(`/ds${url}`)
            }

            return this.localeUrl(url)
        },
    },
}
